export default "__VITE_ASSET__zrNsObEH__"